import '~/stylesheets/react-components/campaign-search.scss';
import CampaignCard from './CampaignCard';
import SearchBar from './SearchBar';
import cx from 'classnames';
import loadingGif from '~/images/icons/loading.gif';
import noResultsImg from '~/images/icons/search/no-results-img.svg';
import store from '~/javascripts/store.js';
import { observer } from 'mobx-react';
import { useEffect } from 'react';

const ParentCampaignSearch = observer((props) => {
  const { campaigns, isSubmitting, page, totalPages } = store.campaignSearch;

  useEffect(() => {
    store.campaignSearch.parentCampaignId = props.parentCampaignId;
    store.campaignSearch.fetchChildCampaigns();
  }, []);

  const shouldShowPagination = () => totalPages > 1;

  const shouldDisable = (disabledPage) => isSubmitting || page === disabledPage;

  const handlePageClick = (clickedPage) => {
    store.campaignSearch.page = clickedPage;
    store.campaignSearch.fetchChildCampaigns();
  };

  const cardsToShow = () => {
    if (campaigns[0]) {
      return campaigns.map((campaign) => (
        <CampaignCard campaign={campaign} key={campaign.id} pill={null} />
      ));
    } else {
      return (
        <div className='no-results-container flex flex-col justify-center items-center py-10 px-5 gap-7 self-stretch rounded bg-cw-white'>
          <img
            alt='no results img'
            className='no-results-img'
            src={noResultsImg}
          />
          <div className='text flex flex-col items-center gap-2 text-center'>
            <div className='header heading-l'>No results found</div>
            <p className='body-m'>
              We couldn’t find what you searched for. <br /> Try searching
              again.
            </p>
          </div>
        </div>
      );
    }
  };

  return (
    <div
      className='campaign-search theme-design-system-v1 bg-cw-brand-yellow-100 flex flex-col px-6 lg-px-18 items-center'
      id='top-of-campaign-search'
    >
      <h2 className='header heading-xl mx-auto text-center pb-6'>
        {props.header}
      </h2>
      {props.subheader && (
        <div className='subheader body-default mx-auto text-center pb-10'>
          {props.subheader}
        </div>
      )}
      {props.showSearchField && <SearchBar />}
      {isSubmitting ? (
        <div className='loading-gif p-10'>
          <img alt='loading-gif' src={loadingGif} />
        </div>
      ) : (
        <div className='campaign-cards-wrapper pt-6 flex lg-flex-wrap lg-flex-row flex-col lg-self-stretch items-center justify-center gap-x-12 gap-y-16'>
          {cardsToShow()}
        </div>
      )}
      {shouldShowPagination() && (
        <div className='pages-container flex justify-center items-center gap-8 pt-16'>
          <a
            className={cx('prev-arrow w-6 h-4 bg-no-repeat', {
              disabled: shouldDisable(1),
            })}
            href='#top-of-campaign-search'
            onClick={() => handlePageClick(page - 1)}
          />
          <div className='heading-m page-number text-cw-black'>{`${page} of ${totalPages}`}</div>
          <a
            className={cx('next-arrow w-6 h-4 bg-no-repeat', {
              disabled: shouldDisable(totalPages),
            })}
            href='#top-of-campaign-search'
            onClick={() => handlePageClick(page + 1)}
          />
        </div>
      )}
    </div>
  );
});

export default ParentCampaignSearch;
